// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Deal } from '@interfaces/deal.interfaces';
import { DdjRouteOneErrorCodes } from '@interfaces/document.interfaces';
import { VendorService } from '@services/vendor.service';
import { catchError, takeWhile } from 'rxjs';
import { R1UserDataModalComponent } from './r1-user-data-modal.component';
import { DealershipService } from '../../services/dealership.service';
import { SettingsService } from '@services/settings.service';

@Component({
    selector: 'app-r1-jacket-modal',
    templateUrl: './r1-jacket-modal.component.html',
    styleUrls: ['./r1-jacket-modal.component.scss'],
})
export class R1JacketModalComponent implements OnInit, OnDestroy {
    private isComponentAlive = true;

    public isLoading = false;
    public deal: Deal;
    public routeOneResponse: any;
    tenantSupportEmail: string;
    tenantSupportPhone: string;

    constructor(
        private dialogRef: MatDialogRef<R1JacketModalComponent>,
        private readonly dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private readonly vendorService: VendorService,
        private readonly dealershipService: DealershipService,
        private readonly settingsService: SettingsService
    ) {}

    ngOnInit() {
        this.deal = this.data.deal;

        this.dealershipService.dealer$.pipe(takeWhile(() => this.isComponentAlive)).subscribe(async (dealer) => {
            ({ supportEmail: this.tenantSupportEmail, supportPhone: this.tenantSupportPhone } = await this.settingsService.getOemSettings(dealer.oemCode));
        });
    }

    retrieveRIC() {
        this.isLoading = true;
        this.vendorService
            .routeOneGetJacket(this.deal.dealerId, this.deal.dealId, this.deal.buyer.firstName, this.deal.buyer.lastName, this.deal.vehicle.vin)
            .pipe(takeWhile(() => this.isComponentAlive))
            .subscribe((response) => {
                //This error workflow that reports back to user is good enough for now. ccox 8/1/23
                if (response?.error) {
                    if (
                        response.error.name?.includes(DdjRouteOneErrorCodes.EnrolledHasBadCreds.valueOf().toString(), 0) ||
                        response.error.name?.includes(DdjRouteOneErrorCodes.EnrolledMissingDealerId.valueOf().toString(), 0)
                    ) {
                        this.vendorService
                            .getRouteOneUserInfo(this.deal.dealerId)
                            .pipe(takeWhile(() => this.isComponentAlive))
                            .subscribe((r1UserInfo) => {
                                const dialogRef = this.dialog.open(R1UserDataModalComponent, {
                                    width: '700px',
                                    closeOnNavigation: false,
                                    disableClose: true,
                                    data: {
                                        deal: this.deal,
                                        r1DealerId: r1UserInfo?.data?.routeOneDealerId,
                                    },
                                });
                            });
                    } else if (DdjRouteOneErrorCodes.NotEnrolled) {
                        this.routeOneResponse = {
                            error: true,
                            title: 'Enrollment Error',
                            message:
                                response.error.message ||
                                `You must enroll with Route One to use this feature. Please contact support. Email: ${this.tenantSupportEmail}, Phone: ${this.tenantSupportPhone} }`,
                        };
                    } else {
                        //This will capture any bad header request DdjRouteOneErrorCodes.BadAuditCreds
                        this.routeOneResponse = {
                            error: true,
                            title: response?.error.title,
                            message: response.error.message || 'Could not sync with RouteOne. Plase try again.',
                        };
                    }
                } else if (response?.data === true) {
                    this.dialogRef.close({ refresh: true });
                }
                this.isLoading = false;
            });
    }

    close() {
        this.dialogRef.close();
    }

    ngOnDestroy(): void {
        this.isComponentAlive = false;
    }
}
